import { Link } from "react-router-dom";
import styled from "styled-components";
import { mobile, tablet } from "../responsive";

const Container = styled.div`
    flex: 1;
    margin: 3px;
    height: 70vh;
    position: relative;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${mobile({height: "30vh" })}
`;

const Info = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    background: rgb(27,40,52);
    background: linear-gradient(66deg, rgba(27,40,52,0.2329306722689075) 41%, rgba(79,156,227,0.21052170868347342) 100%);
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const Title = styled.h1`
    color: white;
    margin-bottom: 20px;
    ${tablet({fontSize: "25px" })}
`;

const Button = styled.button`
    border:none;
    border-radius: 50px;
    padding: 12px;
    background: rgb(26,215,143);
    background: linear-gradient(66deg, rgba(26,215,143,0.9808298319327731) 41%, rgba(0,212,255,1) 100%);
    color:white;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.5s ease;
    ${tablet({fontSize: "12px" })}

    &:hover {
        transform: scale(1.2);
    }
`;

const CategoryItem = ({ item }) => {
    return (
        <Container>
            <Link to={`/products/${item.cat}`}>
            <Image src={item.img} />
            <Info>
                <Title>{item.title}</Title>
                <Button>SHOP NOW</Button>
            </Info>
            </Link>
        </Container>
        );
    };

export default CategoryItem;